import { useRoutes } from 'react-router-dom';

import { AbilityContext, Can } from 'context/Can';

// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import config from 'config';
import { useContext } from 'react';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    const ability = useContext(AbilityContext);
    const mainRoutes = { ...MainRoutes };
    mainRoutes.children = MainRoutes.children.filter((route) => {
        return ability.can('all', route.include);
    });
    return useRoutes([MainRoutes, AuthenticationRoutes], config.basename);
}
